/* eslint-disable react/prop-types */

import React, { useContext, useRef } from "react";
import { PropTypes } from "prop-types";
import { graphql, Link } from "gatsby";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import Layout from "~components/Layout";
import ScreenHeight from "~components/ScreenHeight";
import SEO from "~components/SEO";
import Typer from "~components/Typer";
import TyperSection from "~components/TyperSection";
import { splitStringToParagraphs } from "~utils/helpers";

const ProcessPage = ({ data, location }) => {
  const { windowHeight } = useContext(DocumentContext);

  //

  const { frontmatter } = data.markdownRemark;

  //

  const articles = [];

  let activeSection = 0;

  if (frontmatter?.scrollArticles?.[0]) {
    frontmatter.scrollArticles.forEach((scrollArticle, scrollArticleIndex) => {
      scrollArticle.ref = useRef();

      articles.push(scrollArticle);

      if (
        scrollArticle?.ref?.current &&
        scrollArticle.ref.current.getBoundingClientRect().top < windowHeight / 2
      ) {
        activeSection = scrollArticleIndex;
      }
    });
  }

  //

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="process-page w-full relative bg-white">
        <TyperSection
          heading={frontmatter.heading}
          imageText={frontmatter.imageText}
          imageCaption={frontmatter.imageCaption}
          imageColor="orange"
          typerColor="pank"
        />

        <div className="grid text-orange">
          <article className="animation-appear-down animation-delay-3 grid-end-6 xs:grid-end-8 mt-v7 xs:mt-v14">
            {splitStringToParagraphs(
              frontmatter.introText,
              `b1 universal-sans`
            )}
          </article>
        </div>

        <article className="type-list grid pb-v6 text-orange">
          <ScreenHeight className="grid-end-6 xs:grid-end-8 grid-start-1 sticky xs:hidden top-0 left-0 flex flex-col justify-center">
            <h3>
              <Typer
                className="b2 universal-sans"
                color="orange"
                text={frontmatter.scrollArticles[activeSection].subheading}
              />
            </h3>

            <h2
              className="mt-v1"
              style={{ height: `8vw`, paddingRight: `1vw` }}
            >
              <Typer
                className="f2 schnyder"
                color="prange"
                text={frontmatter.scrollArticles[activeSection].heading}
              />
            </h2>
          </ScreenHeight>

          {articles.map(({ content, heading, ref, subheading }) => {
            return (
              <section
                ref={ref}
                className="grid-end-6 xs:grid-end-8 grid-start-7 xs:grid-start-1 xs:mt-v28 relative"
              >
                <ScreenHeight
                  className="w-full relative flex flex-col justify-center"
                  noMobile
                >
                  <header className="xs-only">
                    <p className="b1 universal-sans mb-v4">{subheading}</p>
                    <h4 className="f3 schnyder pr-v10 mb-v7 xs:mb-v7">
                      {heading}
                    </h4>
                  </header>

                  <p className="b1 universal-sans">{content}</p>
                </ScreenHeight>
              </section>
            );
          })}
        </article>

        <section className="process-page__button w-full relative">
          <div className="flex items-center justify-center mb-v7 xs:mb-v14">
            <Link to="/work">
              <Button className="" color="orange" filled text="See our work" />
            </Link>
          </div>
        </section>
      </Layout>
    </>
  );
};

ProcessPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({})
    })
  }).isRequired,
  location: PropTypes.shape({}).isRequired
};

export default ProcessPage;

export const query = graphql`
  query ProcessPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        heading
        imageText
        imageCaption
        introText
        scrollArticles {
          subheading
          heading
          content
        }
        seoDescription
        seoKeywords
      }
    }
  }
`;
